/**
 * Bottom-nav tab icons as inline SVG (stroke = currentColor so CSS themes them).
 * Replaces the old emoji glyphs — crisp at any DPI, no image assets, recolorable.
 */
const S = (body: string): string =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${body}</svg>`;

export const TAB_ICONS: Record<string, string> = {
  // mine — gem (crypto mining)
  main: S('<path d="M6 3h12l3 6-9 12L3 9z"/><path d="M3 9h18M9 3 6.5 9 12 21l5.5-12L15 3"/>'),
  // exchange — two candlesticks
  exchange: S('<path d="M7 4v16M17 4v16"/><rect x="5" y="8" width="4" height="8" rx="1"/><rect x="15" y="6" width="4" height="7" rx="1"/>'),
  // upgrades — up chevron
  upgrades: S('<path d="M12 20V7M6 12l6-6 6 6"/>'),
  // prestige — rebirth cycle
  prestige: S('<path d="M20 11a8 8 0 1 0-1.6 5.3"/><path d="M20 4v5h-5"/>'),
  // dark pool — dice (betting)
  darkpool: S('<rect x="4" y="4" width="16" height="16" rx="3"/><circle cx="9" cy="9" r="1"/><circle cx="15" cy="9" r="1"/><circle cx="9" cy="15" r="1"/><circle cx="15" cy="15" r="1"/>'),
  // achievements — trophy
  achievements: S('<path d="M8 21h8M12 17v4M7 4h10v4a5 5 0 0 1-10 0zM7 6H4v1a3 3 0 0 0 3 3M17 6h3v1a3 3 0 0 1-3 3"/>'),
  // settings — gear
  settings: S('<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M2 12h3M19 12h3M4.9 19.1 7 17M17 7l2.1-2.1"/>'),
};
